var _path, _path2, _path3, _circle;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgStandardErrorInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "standard-error-info_svg__icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    width: 200,
    height: 200,
    preserveAspectRatio: "xMidYMid meet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 887.04a378.026667 378.026667 0 0 1-147.2-725.333333 380.586667 380.586667 0 0 1 293.973333 0 377.6 377.6 0 0 1 230.826667 348.16h-64a314.026667 314.026667 0 0 0-191.573333-289.28 316.586667 316.586667 0 0 0-244.48 0 314.026667 314.026667 0 0 0 0 578.133333 316.586667 316.586667 0 0 0 244.48 0 313.173333 313.173333 0 0 0 99.84-67.413333l45.226666 45.226666A376.746667 376.746667 0 0 1 512 887.04z",
    fill: "#F7B100"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M853.333333 580.266667a27.733333 27.733333 0 0 1-19.626666-8.106667l-79.36-79.36a27.733333 27.733333 0 1 1 39.253333-39.253333L853.333333 512l59.733334-59.733333a27.733333 27.733333 0 0 1 39.253333 39.253333l-79.36 79.36a27.733333 27.733333 0 0 1-19.626667 9.386667z",
    fill: "#F7B100"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M512 622.48a32 32 0 0 1-32-32v-298.666667a32 32 0 0 1 64 0v298.666667a32 32 0 0 1-32 32z",
    fill: "#F7B100",
    "data-spm-anchor-id": "a313x.search_index.0.i3.67b53a81CvYl2v",
    className: "standard-error-info_svg__selected"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 720,
    r: 45,
    fill: "#F7B100"
  })));
}

export default SvgStandardErrorInfo;